<template>
  <div class="max-w-[2560px] mx-auto">
    <!-- Navigation Bar -->
    <div>
      <navigation-bar></navigation-bar>
    </div>

    <!-- Header Section -->
    <div>
      <header-component
        :img="career.image_path"
        :title="getLocalized(career, 'title')"
        :detailed="getLocalized(career, 'description')"
      ></header-component>
    </div>

    <!-- Career Section -->
    <div
      class="p-4 md:p-[50px] lg:p-[100px] w-full h-auto flex flex-col gap-[10px] lg:gap-[20px]"
    >
      <h1 class="font-bold text-[24px] md:text-[32px] lg:text-[36px]">
        {{ getLocalized(contentData, "title") }}
      </h1>
      <p class="text-[16px] lg:text-[20px]">
        {{ getLocalized(contentData, "description") }}
      </p>
    </div>

    <!-- Career Card Section -->
    <div>
      <career-card></career-card>
    </div>

    <!-- Footer Section -->
    <div>
      <footer-view></footer-view>
    </div>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent.vue";
import NavigationBar from "@/view/NavigationBar.vue";
import footerView from "@/view/footerView.vue";
import CareerCard from "../components/CareerComponent/CareerCard.vue";
import { useLocalization } from "@/composable/useLocalization";
import axios from "axios";
import { fetchContentSection } from "@/composable/apiService";
export default {
  components: { HeaderComponent, NavigationBar, footerView, CareerCard },
  data() {
    return {
      career: {},
      api: process.env.VUE_APP_API_KEY,
      contentData: {},

      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  mounted() {
    this.fetchCareer();
  },
  methods: {
    async fetchCareer() {
      this.contentData = await fetchContentSection(12);
      const response = await axios.get(this.api + "/api/sliders");
      this.career = response.data.items;
      this.career = this.career
        .map((item) => ({
          ...item,
          image_path: `${this.api}${item.image_path}`,
        }))
        .find((item) => item.id === 4);
    },
    formatContent(content) {
      if (!content) return ""; // Return empty if no content

      // Trim any extra spaces around the content
      let formattedContent = "";
      let tempContent = content.trim();

      // Split content by period (.) or Khmer full stop (។)
      const sentences = tempContent.split(/(?<=\.|។)/); // Split by period or Khmer full stop

      let line = "";
      sentences.forEach((sentence) => {
        const sentenceWithDot = sentence.trim(); // Ensure sentence ends with a period or full stop

        // If line length is under 500 characters, add to the current line
        if (line.length + sentenceWithDot.length <= 300) {
          line += sentenceWithDot + " "; // Add space after sentence
        } else {
          // Otherwise, add the current line to formattedContent and start a new line
          formattedContent += line.trim() + "<br><br>";
          line = sentenceWithDot + " "; // Start new line with the current sentence
        }
      });

      // Add any remaining content in the last line
      if (line.length > 0) {
        formattedContent += line.trim();
      }

      return formattedContent; // Return the formatted content with <br> tags
    },
  },
};
</script>
